import { FC } from 'react';
import { Container } from './ErrorScreen.styles';
import { WifiOffOutlined } from '@mui/icons-material';

interface LoadingProps {
	fullScreen?: boolean;
}

const Error: FC<LoadingProps> = ({ fullScreen }) => {
	return (
		<Container $fullScreen={fullScreen}>
			<WifiOffOutlined fontSize='inherit' />
			<span>Oops! Parece que algo deu errado.</span>
			<span>Por favor, tente novamente em alguns instantes.</span>
		</Container>
	);
};

export default Error;
